import { defineComponent as _defineComponent } from 'vue'

import { Tooltip } from 'element-ui';
const __default__ = {
  name: 'utm-attribution',
  components: { [Tooltip.name]: Tooltip },
};

import { computed } from 'vue';
import {
  utmState, utmChipLabel, utmDetailRows, utmHasDetail, utmLineSegments,
} from '@/util/utmAttribution';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  source: { type: String, default: '' },
  medium: { type: String, default: '' },
  campaign: { type: String, default: '' },
  referrer: { type: String, default: '' },
  // 'chip' for list rows and cards, 'line' for detail pages and the booking drawer
  mode: { type: String, default: 'chip' },
  // Optional tim-icons class (without the tim-icons prefix) shown before the chip label
  icon: { type: String, default: '' },
  // Rendered when there is no UTM row at all; empty string renders nothing
  emptyText: { type: String, default: '' },
},
  setup(__props) {

const props = __props



const utm = computed(() => ({
  source: props.source,
  medium: props.medium,
  campaign: props.campaign,
  referrer: props.referrer,
}));

const state = computed(() => utmState(utm.value));
const chipLabel = computed(() => utmChipLabel(utm.value));
const rows = computed(() => utmDetailRows(utm.value));
const hasDetail = computed(() => utmHasDetail(utm.value));
const lineSegments = computed(() => utmLineSegments(utm.value));

return { __sfc: true,props, utm, state, chipLabel, rows, hasDetail, lineSegments }
}

})